import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import JustLaunched from "../components/JustLaunched";
import Hero from "../sections/Hero";
import Section1 from "../sections/Section1";
import Section2 from "../sections/Section2";
import Section4 from "../sections/Section4";
import Section5 from "../sections/Section5";
import Section6 from "../sections/Section6";
import FAQ from "../pages/FAQ";

import {
  Button,
  Input,
  useToast,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Box,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const Referred = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [ethereumAddress, setEthereumAddress] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [datas, setDatas] = useState("");
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    event.preventDefault();

    try {
      const response = await fetch(
        "https://chainpulseserver.onrender.com/api/referred-by-gotbit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({ ethereumAddress }),
        }
      );

      const data = await response.json();
      setDatas(data);

      if (!response.ok) {
        toast({
          description: datas?.error || "Thats an error",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }

      toast({
        description: "Submitted!",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      setIsSubmitting(false);
      navigate("/start");
    } catch (error) {
      setIsSubmitting(false);

      // Handle error
    }
  };

  useEffect(() => {
    onOpen();
  }, []);
  return (
    <div>
      <Modal
        size={{ base: "full", md: "md" }}
        isCentered
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay bg="none" backdropFilter="auto" backdropBlur="2px" />
        <ModalContent bg={{ base: "black", md: "#212121" }} borderRadius="10px">
          <ModalHeader>Hey! You're from Gotbit!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Accessing ChainPulse through this link makes you eligible for
            rewards from GotBit in the future! Input your Solana address below
            to secure your spot.
            <Box mt="20px" as="form" onSubmit={handleSubmit}>
              <FormControl>
                <FormLabel>Solana Address</FormLabel>
                <Input
                  borderRadius="10px"
                  type="text"
                  value={ethereumAddress}
                  onChange={(e) => setEthereumAddress(e.target.value)}
                  placeholder="Enter Solana Address"
                />
              </FormControl>
              <Button
                borderRadius="10px"
                isLoading={isSubmitting}
                w="100%"
                type="submit"
                mt={4}
              >
                Submit
              </Button>
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
      <JustLaunched />
      <Header />
      <Hero />
      <Section1 />
      <Section2 />
      <Section5 />
      <Section4 />
      <FAQ />
      <Section6 />
      <Footer />
    </div>
  );
};

export default Referred;
